// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Admin } from './admin';
import { AdminContactRole } from './admin-contact-role';
import { Contact } from './contact';
import { Counterparty } from './counterparty';
import { CounterpartyType } from './counterparty-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class AdminContact extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  adminContactId!: number;
  adminContactRoleId?: number;
  adminId!: number;
  contactId?: number;
  counterpartyId?: number;
  counterpartyTypeId?: number;
  createdBy!: string;
  createdDate!: Date;
  ts!: string;
  updatedBy!: string;
  updatedDate!: Date;
  admin!: Admin;
  adminContactRole!: AdminContactRole;
  contact!: Contact;
  counterparty!: Counterparty;
  counterpartyType!: CounterpartyType;
}

